import React from 'react'
import { NextSeo } from 'next-seo'

import Meta from '../../components/Meta'
import { FileProvider } from '../../lib/files'
import { IData } from '@/components/blogImg/types'
import { CourseCard, ICourse } from '@/components/course'
import { ContactHome } from '@/components/contact'
import Config from '../../site.config'

interface IProps {
  data: IData[]
}

const Courses = (props: IProps) => {
  const { data } = props

  const lista = data.map((item: ICourse, index: number) => {
    return <CourseCard key={index} course={item} />
  })

  return (
    <>
      <Meta title='Cursos' />
      <NextSeo
        title='Romikya Labs'
        description={Config.site.description}
        openGraph={{
          url: Config.site.URL,
          title: Config.site.title,
          description: Config.site.description,
          images: [
            {
              url: Config.site.preview,
              width: 424,
              height: 392,
              alt: 'banner',
              type: 'image/png',
            },
          ],
          site_name: 'Romikya Labs',
        }}
      />
      <div className='pt-[5.5rem] lg:pt-24'>
        {/* <!-- Courses --> */}

        <div className='lg:flex'>
          {/* <!-- Container for demo purpose --> */}
          <div className='my-24 mx-auto md:px-6'>
            {/* <!-- Section: Design Block --> */}
            <section className='mb-32 text-center md:text-left'>
              {lista}
            </section>
            {/* <!-- Section: Design Block --> */}
          </div>
          {/* <!-- Container for demo purpose --> */}
        </div>
        {/* <!-- end courses --> */}
      </div>
      <ContactHome />
    </>
  )
}

export async function getStaticProps() {
  const provider = new FileProvider()
  const postList = provider.getCourses()

  return {
    props: {
      data: postList,
    },
  }
}

export default Courses
